<script setup>
import { computed } from "vue";
import ChartCardOptions from "./ChartCardOptions.vue";
import ContentCardOptions from "./ContentCardOptions.vue";
import AnalysisCardOptions from "./AnalysisCardOptions.vue";
import { contentSubtype } from "./constants";

const props = defineProps({
  card: { type: Object, required: true },
});

const isChartCard = computed(() => ["question", "recode"].includes(props.card.card_type));
const isContentCard = computed(() => !!contentSubtype(props.card));
const isAnalysisCard = computed(() => props.card.card_type === "analysis");
</script>

<template>
  <ChartCardOptions v-if="isChartCard" :key="card.id" :card="card" />
  <ContentCardOptions v-else-if="isContentCard" :card="card" />
  <AnalysisCardOptions v-else-if="isAnalysisCard" :card="card" />
</template>
